export const noteSchema = `
            note
            createdBy
            modifiedBy
            createdDateTime     
            modifiedDateTime
            type
    `;
